require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./interviste-bruno-brocchi.json") })
        }
      }, "path---interviste-bruno-brocchi");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---interviste-bruno-brocchi!./.cache/json/interviste-bruno-brocchi.json
// module id = 670
// module chunks = 231608221292675